import React from "react";
import i18n from "i18next";
import "./MutualExclusionOverlay.scss";

export default function MutualExclusionOverlay({ busy, originatingTab, onViewProgress, onCancel }) {
  if (!busy) return null;
  const scopeLabel = busy.scope === "scene" ? "scene" : "course";
  return (
    <div className="mutual-exclusion-overlay">
      <div className="mutual-exclusion-overlay__card">
        <div className="mutual-exclusion-overlay__icon">
          <i className="material-icons">hourglass_top</i>
        </div>
        <div className="mutual-exclusion-overlay__title">
          {i18n.t("Workflow.generating_for", {
            defaultValue: `Generating ${scopeLabel === "scene" ? "suggestions" : "workflow detail"}…`,
          })}
        </div>
        <div className="mutual-exclusion-overlay__actions">
          <button type="button" className="btn btn-outline-secondary" onClick={onViewProgress}>
            {i18n.t("Workflow.view_progress", { defaultValue: "View progress" })}
          </button>
          <button type="button" className="btn btn-danger" onClick={onCancel}>
            {i18n.t("Workflow.cancel", { defaultValue: "Cancel" })}
          </button>
        </div>
      </div>
    </div>
  );
}
